import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

const contactInfo = [
  {
    icon: <FaMapMarkerAlt />,
    title: 'Address',
    details: '4 Babatope Bajide Cres, Lekki Phase 1, Lagos'
  },
  {
    icon: <FaPhone />,
    title: 'Phone',
    details: '+2349125983173'
  },
  {
    icon: <FaEnvelope />,
    title: 'Email',
    details: 'contact@botrex.pro'
  },
  {
    icon: <FaClock />,
    title: 'Hours',
    details: 'Mon - Fri: 9AM - 6PM'
  }
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  return (
    <div className="min-h-screen bg-nvidia-dark py-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Get in <span className="text-nvidia-green">Touch</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Have a question or want to discuss your AI project? We're here to help!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Contact Form */}
          <div className="lg:col-span-2">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 bg-nvidia-dark-800 border border-nvidia-green/20 rounded-lg focus:border-nvidia-green focus:ring-1 focus:ring-nvidia-green outline-none transition-colors"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 bg-nvidia-dark-800 border border-nvidia-green/20 rounded-lg focus:border-nvidia-green focus:ring-1 focus:ring-nvidia-green outline-none transition-colors"
                    required
                  />
                </div>
              </div>
              <div>
                <label htmlFor="subject" className="block text-sm font-medium mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-2 bg-nvidia-dark-800 border border-nvidia-green/20 rounded-lg focus:border-nvidia-green focus:ring-1 focus:ring-nvidia-green outline-none transition-colors"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  className="w-full px-4 py-2 bg-nvidia-dark-800 border border-nvidia-green/20 rounded-lg focus:border-nvidia-green focus:ring-1 focus:ring-nvidia-green outline-none transition-colors resize-none"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-nvidia-green text-black py-3 px-6 rounded-lg font-semibold hover:bg-opacity-90 transition-colors"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className="flex items-start p-6 bg-nvidia-dark-800 rounded-lg border border-nvidia-green/20"
              >
                <div className="text-nvidia-green text-2xl mr-4">
                  {info.icon}
                </div>
                <div>
                  <h3 className="font-bold mb-2">{info.title}</h3>
                  <p className="text-gray-400">{info.details}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
